module.exports = __webpack_public_path__ + "img/play.63a5d6a1.svg";